module.exports = __webpack_public_path__ + "img/9.27a3ab36.jpg";